const _zairyuuStatus=[
    {"name":"留学","name_en":"Student visa"},
    {"name":"技能実習","name_en":"Technical intern training visa"},
    {"name":"高度人材","name_en":"Highly skilled professional visa"},
    {"name":"特定技能","name_en":"Specified skilled worker visa"},
    {"name":"その他","name_en":"Other"}
];

export default {
    data () {
      return {
        zairyuu: _zairyuuStatus,
      }
    }
  }
  
  